import type { SelectComboFieldProps } from "components/Forms/SelectCombo/SelectCombo";
import { SelectListWrapper } from "components/Forms/SelectCombo/SelectListWrapper";
import { useSchemesQueryState } from "hooks/useScheme";
import type React from "react";

type SchemeSelectFormComponentProps = Omit<SelectComboFieldProps, "options"> & {
  allowAll?: boolean;
};
export default function SchemeSelectFormComponent(
  props: SchemeSelectFormComponentProps,
): React.ReactElement {
  const { allowAll = false, ...rest } = props;
  const { schemes, loading, error } = useSchemesQueryState();
  return (
    <SelectListWrapper
      {...rest}
      items={schemes}
      toOption={(scheme) => ({
        label: `${scheme.scheme_name} (${scheme.scheme_id})`,
        value: scheme.scheme_id,
      })}
      loading={loading}
      dataError={error}
      leadingOptions={allowAll ? [{ label: "All", value: "undefined" }] : []}
      placeholder="All"
      labels={{ empty: "No Groups", loading: "Loading Schemes" }}
    />
  );
}
